
import Vue from "vue";
import { mapState } from "vuex";
import ScytheResultsTable from "@/components/ScytheResultsTable.vue";
import { ScythePlay } from "@/types";

export default Vue.extend({
  name: "scores-scythe",

  components: {
    ScytheResultsTable,
  },

  data() {
    return {
      results: [] as { [key: string]: any },
      typeResults: "best",
      bestResults: [] as { [key: string]: any },
      worstResults: [] as { [key: string]: any },
      averageResults: [] as { [key: string]: any },
    };
  },

  computed: {
    ...mapState(["scythePlays", "scytheFactions"]),
  },

  async beforeMount() {
    if (!this.scythePlays.length) {
      this.$store.dispatch("getScythePlays").then(() => this.init());
    } else {
      this.init();
    }
  },

  watch: {
    typeResults(val): void {
      switch (val) {
        case "worst":
          if (!this.worstResults.length) {
            this.worstResults = this.getWorstResults();
          }
          this.results = this.worstResults;
          break;
        case "average":
          if (!this.averageResults.length) {
            this.averageResults = this.getAverageResults();
          }
          this.results = this.averageResults;
          break;
        case "best":
        default:
          this.results = this.bestResults;
      }
    },
  },

  methods: {
    init(): void {
      this.bestResults = this.getBestResults();
      this.results = this.bestResults;
    },

    getBestResults(): { [key: string]: any } {
      const results: { [key: string]: any } = [];
      this.scythePlays.forEach((play: ScythePlay) => {
        if (!results[play.automa.faction]) {
          results[play.automa.faction] = [];
        }
        if (
          !results[play.automa.faction][play.human.faction] ||
          play.human.score >
            results[play.automa.faction][play.human.faction].human.score
        ) {
          results[play.automa.faction][play.human.faction] = play;
        }
      });
      return results;
    },

    getWorstResults(): { [key: string]: any } {
      const results: { [key: string]: any } = [];
      this.scythePlays.forEach((play: ScythePlay) => {
        if (!results[play.automa.faction]) {
          results[play.automa.faction] = [];
        }
        if (
          !results[play.automa.faction][play.human.faction] ||
          play.human.score <
            results[play.automa.faction][play.human.faction].human.score
        ) {
          results[play.automa.faction][play.human.faction] = play;
        }
      });
      return results;
    },

    getAverageResults(): { [key: string]: any } {
      const results: { [key: string]: any } = [];
      this.scythePlays.forEach((play: ScythePlay) => {
        if (!results[play.automa.faction]) {
          results[play.automa.faction] = [];
        }
        if (!results[play.automa.faction][play.human.faction]) {
          results[play.automa.faction][play.human.faction] = [];
        }
        results[play.automa.faction][play.human.faction].push({
          human: play.human.score,
          automa: play.automa.score,
        });
      });
      for (const automaFaction in results) {
        for (const humanFaction in results[automaFaction]) {
          const scores = [...results[automaFaction][humanFaction]];
          let humanScores = 0;
          let automaScores = 0;
          scores.forEach((score) => {
            humanScores += score.human;
            automaScores += score.automa;
          });
          const humanAverage = Math.round(humanScores / scores.length);
          const automaAverage = Math.round(automaScores / scores.length);
          results[automaFaction][humanFaction] = {};
          results[automaFaction][humanFaction].human = {
            faction: humanFaction,
            score: humanAverage,
            winner: humanAverage > automaAverage,
          };
          results[automaFaction][humanFaction].automa = {
            faction: automaFaction,
            score: automaAverage,
            winner: automaAverage > humanAverage,
          };
        }
      }
      return results;
    },
  },
});
